import React, {InputHTMLAttributes, ReactNode} from 'react';
import classnames from 'classnames';
import ButtonAction from '../ButtonAction';
import {toAbsoluteUrl} from '../../../../../_metronic/_helpers';

interface DNDFileUploadProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: ReactNode;
  showIcon?: boolean;
  variant?: string;
  customContainerStyles?: string;
  customLabelStyles?: string;
}

const ButtonUploadFile = ({
                            label,
                            showIcon,
                            title,
                            customContainerStyles,
                            customLabelStyles,
                            disabled,
                            variant = 'upload',
                            ...rest
                          }: DNDFileUploadProps) => {
  const labelStyles = classnames(
    `w-100 mb-0 cursor-pointer d-flex align-items-center justify-content-center`,
    customLabelStyles
  );

  return (
    <ButtonAction
      variant={variant}
      avoidDoubleClick={false}
      label={
        <label className={labelStyles} style={{
          height: 38,
          cursor: 'pointer',
          position: 'relative',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'transparent'
        }}>
          {showIcon && (
            <img
              src={toAbsoluteUrl('/media/common/Upload_file.svg')}
              alt="file"
              className={label ? 'mr-2' : ''}
              height={24}
            />
          )}
          {label}
          <input
            type="file"
            disabled={disabled}
            {...rest}
            style={{
              position: 'absolute',
              inset: 0,
              width: '100%',
              height: '100%',
              opacity: 0,
              cursor: 'pointer'
            }}
          />
        </label>
      }
      title={title}
      customClassnames={classnames('p-0', customContainerStyles)}
      disabled={disabled}
      onClick={() => {}}
    />
  );
};

export default ButtonUploadFile;
